import axios from "axios";
import { ID_CUENTA } from "config/general/Configuracion";
import { API_NOTIFICACIONES } from "config/general/Configuracion";
import { API_GATEWAY_URL, HEADERS, SESION, API_USUARIO } from "config/general/Configuracion";

class ApiClient {
  constructor() {
    this.url = API_GATEWAY_URL;
  }

  ingresoInicioSolicitud = () => {
    return {
      method: "get",
      url: `${this.url}/v1/acceso/authDiff`,
      headers: HEADERS(),
    };
  };

  verificarExistenciaUsuario = async (correo, cuenta) => {
    const url = `${API_USUARIO}/v1/usuario/ciudad/existeUsuario/${cuenta}/${correo}`;
    try {
      const response = await axios.get(url);
      return response.data; // true o false según la API
    } catch (error) {
      console.error("❌ Error verificando usuario:", error);
      return false;
    }
  };

  obtenerListaDocumentos = async (cuenta) => {
    const url = `${API_USUARIO}/v1/usuario/tipo-documento/${cuenta}`;
    try {
      const response = await axios.get(url);
      return response.data; // true o false según la API
    } catch (error) {
      console.error("❌ Error verificando usuario:", error);
      return false;
    }
  }

  crearUsuario = async (cuenta, datos) => {
    const url = `${API_USUARIO}/v1/usuario/ciudad/${cuenta}`;
    try {
      const response = (await axios.post(url, datos));
      return response.data; // true o false según la API
    } catch (error) {
      console.error("❌ Error verificando usuario:", error);
      return error;
    }
  }

  listarDocumentos = () => {
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/usuario/tipo-documento/${encodeURIComponent(
        localStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  ingresoCompletarSolicitud = (idSolicitud, A, tokenAuth) => {
    //auth?idSolicitud=w&A=w&contentAuth=w
    var para1 = "idSolicitud=" + encodeURIComponent(idSolicitud);
    var para2 = "A=" + encodeURIComponent(A);
    var para3 = "contentAuth=" + encodeURIComponent(tokenAuth);
    let respuesta = {
      method: "get",
      url: `${this.url}/v1/acceso/auth?${para1}&${para2}&${para3}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

  salirSesion = () => {
    try {
      const idUsuario = localStorage.getItem("ID_USUARIO");
      const cuenta = localStorage[ID_CUENTA]

       fetch(API_NOTIFICACIONES + "/v1/notificaciones/eliminar", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          idUsuario,
          cuenta
        })
      });

    } catch (error) {

    }
    let respuesta = {
      method: "post",
      url: `${this.url}/v1/acceso/salir/${localStorage[SESION]}`,
      headers: HEADERS(),
    };
    return respuesta;
  };

}
const IngresoSistemaApi = new ApiClient();
export default IngresoSistemaApi;
